// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"imgwithbadge_imgBox__ZRFqN","miaImg":"imgwithbadge_miaImg__aVevU","badge":"imgwithbadge_badge__0TKIM"};